import { __read } from "tslib";
import { useState } from 'react';
import { useEventCallback } from '../useEventCallback';
/**
 * a method for trigger force update
 * @returns force update method
 */
export function useForceUpdate() {
    var _a = __read(useState(Object.create(null)), 2), dispatch = _a[1];
    var memoizedDispatch = useEventCallback(function () {
        dispatch(Object.create(null));
    });
    return memoizedDispatch;
}
